import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
    try { localStorage.removeItem('3dConfiguratorState'); } catch(e) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-8">
          <div className="max-w-md text-center space-y-4">
            <h2 className="text-xl font-bold text-red-600">Etwas ist schiefgelaufen</h2>
            <p className="text-gray-600 text-sm">
              Die Seite konnte nicht geladen werden. Der gespeicherte Zustand wurde zurückgesetzt.
            </p>
            <button
              className="px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800"
              onClick={() => { window.location.reload(); }}>
              Seite neu laden
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
